import { useContext } from "react"
import { Link } from "react-router-dom"

import Badge from "~/v2/components/ui/badge"
import Button from "~/v2/components/ui/button"
import VaasCreateForm from "~/v2/components/vaas/vaas-create-form"
import VaasContext from "~/v2/providers/vaas"

const Create = () => {
  const { createError, createLoading, createVaas } = useContext(VaasContext)

  return (
    <div className="overflow-auto">
      <div className="mx-auto flex h-full w-full max-w-5xl flex-col gap-6 px-6 py-8">
        <div className="flex items-center justify-between gap-3">
          <div>
            <div className="mb-3">
              <Badge>Task 1</Badge>
            </div>
            <h1 className="text-3xl font-semibold text-foreground">
              Create VAAS
            </h1>
            <p className="mt-2 text-sm text-muted-foreground">
              Create VAAS course and attached lesson in one flow.
            </p>
          </div>
          <Link to="/vaas">
            <Button variant="outline">Back to list</Button>
          </Link>
        </div>

        <VaasCreateForm
          createError={createError}
          isLoading={createLoading}
          onCancel={() => window.history.back()}
          onSubmit={createVaas}
        />
      </div>
    </div>
  )
}

export default Create
